import { Component } from '@angular/core';
import { NgModule } from '@angular/core';

@Component({
  selector: 'parksmart-root',
  templateUrl: './ParkSmart.component.html',
  styleUrls: ['./ParkSmart.component.css']
})

export class ParkSmartComponent {



}
